import { render, staticRenderFns } from "./numberblock.vue?vue&type=template&id=a3ec9084&"
import script from "./numberblock.vue?vue&type=script&lang=js&"
export * from "./numberblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports